import { useCallback, useState } from 'react';

export default (initialState = false) => {
  const [state, setState] = useState(initialState);
  const toggleOn = useCallback(() => setState(true), []);
  const toggleOff = useCallback(() => setState(false), []);
  return [state, toggleOn, toggleOff] as const;
};
